/* eslint-disable */
if (typeof visme_resp === 'undefined') {
  ;(function (funcName, baseObj) {
    'use strict'
    funcName = funcName || 'docReady'
    baseObj = baseObj || window
    var readyList = []
    var readyFired = false
    var readyEventHandlersInstalled = false
    function ready () {
      if (!readyFired) {
        readyFired = true
        for (var i = 0; i < readyList.length; i++) {
          readyList[i].fn.call(window, readyList[i].ctx)
        }

        readyList = []
      }
    }

    function readyStateChange () {
      if (document.readyState === 'complete') {
        ready()
      }
    }

    baseObj[funcName] = function (callback, context) {
      if (typeof callback !== 'function') {
        throw new TypeError('callback for docReady(fn) must be a function')
      }

      if (readyFired) {
        setTimeout(function () {
          callback(context)
        }, 1)
        return
      } else {
        readyList.push({ fn: callback, ctx: context })
      }

      if (
        document.readyState === 'complete' ||
        (!document.attachEvent && document.readyState === 'interactive')
      ) {
        setTimeout(ready, 1)
      } else if (!readyEventHandlersInstalled) {
        if (document.addEventListener) {
          document.addEventListener('DOMContentLoaded', ready, false)

          window.addEventListener('load', ready, false)
        } else {
          document.attachEvent('onreadystatechange', readyStateChange)
          window.attachEvent('onload', ready)
        }
        readyEventHandlersInstalled = true
      }
    }
  })('docReady', window)

  var data_w = []
  var data_h = []
  var isChangeOrientation = false

  if (document.readyState == 'complete' || document.readyState == 'interactive') {
    setup_visme()
  } else {
    docReady(setup_visme)
  }

  function visme_resp () {
    var x = document.getElementsByClassName('visme')
    var i
    for (i = 0; i < x.length; i++) {
      x[i].style.overflow = 'hidden'
      const visme_i_w = data_w[i]
      const visme_i_h = data_h[i]

      try {
        var visme_p_w =
          window
            .getComputedStyle(x[i].parentNode, null)
            .getPropertyValue('width')
            .replace('px', '') -
          window
            .getComputedStyle(x[i].parentNode, null)
            .getPropertyValue('padding-left')
            .replace('px', '') -
          window
            .getComputedStyle(x[i].parentNode, null)
            .getPropertyValue('padding-right')
            .replace('px', '')
      } catch (e) {
        var visme_p_w = x[i].parentNode.currentStyle.width.replace('px', '')
      }

      visme_p_w = parseInt(visme_p_w)

      if (isNaN(visme_p_w)) {
        try {
          visme_p_w =
            window
              .getComputedStyle(x[i].parentNode.parentNode, null)
              .getPropertyValue('width')
              .replace('px', '') -
            window
              .getComputedStyle(x[i].parentNode.parentNode, null)
              .getPropertyValue('padding-left')
              .replace('px', '') -
            window
              .getComputedStyle(x[i].parentNode.parentNode, null)
              .getPropertyValue('padding-right')
              .replace('px', '')
        } catch (e) {
          visme_p_w = x[i].parentNode.parentNode.currentStyle.width.replace('px', '')
        }
      }

      visme_p_w = parseInt(visme_p_w)

      var visme_ratio = visme_p_w / visme_i_w
      x[i].width = visme_p_w
      x[i].style.width = visme_p_w + 'px'
      x[i].height = parseInt(visme_i_h * visme_ratio)

      if (isChangeOrientation) {
        var src = x[i].getAttribute('src')
        x[i].setAttribute('src', '')
        x[i].setAttribute('src', src)
        isChangeOrientation = false
      }

      //  x[i].contentWindow.postMessage('{"type":"embed-iframe", "width":"' + x[i].width + 'px", "height":"' + x[i].height + 'px" }', '*');
    }
  }

  function setup_visme () {
    var w
    var state = document.readyState
    if (state == 'complete' || state == 'interactive') {
      var x = document.getElementsByClassName('visme_d')
      var i = x.length
      while (i--) {
        // console.log(x[i].parentNode.clientWidth);
        var ifrm = document.createElement('IFRAME')
        var domain = x[i].getAttribute('data-domain') || 'my'
        ifrm.setAttribute(
          'src',
          '//' + domain + '.visme.co/_embed/' + x[i].getAttribute('data-url') + '?responsive=1'
        )

        ifrm.style.border = 'none'
        ifrm.className = 'visme'
        ifrm.dataset.projectid = x[i].getAttribute('data-url')
        try {
          w = Number(
            window
              .getComputedStyle(x[i].parentNode, null)
              .getPropertyValue('width')
              .replace('px', '')
          )
        } catch (e) {
          w = x[i].parentNode.currentStyle.width.replace('px', '')
        }
        if (w == 'auto') {
          // ie11 bug
          w = Number(
            window
              .getComputedStyle(x[i].parentNode, null)
              .getPropertyValue('width')
              .replace('px', '')
          )
        }

        if (isNaN(w)) {
          w = Number(
            window
              .getComputedStyle(x[i].parentNode.parentNode, null)
              .getPropertyValue('width')
              .replace('px', '')
          )
        }
        if (isNaN(w)) {
          setTimeout(setup_visme, 1000)
          return
        }

        data_h[i] = x[i].getAttribute('data-h')
        data_w[i] = x[i].getAttribute('data-w')

        ifrm.setAttribute('width', w)
        if (navigator.platform.match(/iPhone|iPod|iPad/)) {
          ifrm.setAttribute('scrolling', 'no')
        }
        ifrm.style.width = w + 'px'
        ifrm.setAttribute('height', data_h[i] * (parseInt(w) / data_w[i]))
        ifrm.setAttribute('allowfullscreen', true)
        ifrm.setAttribute('webkitallowfullscreen', true)
        ifrm.setAttribute('mozallowfullscreen', true)
        x[i].parentNode.replaceChild(ifrm, x[i])
      }

      visme_resp()
    }
  }

  var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent'
  var eventer = window[eventMethod]
  var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message'
  var resizeTimer

  eventer('orientationchange', function () {
    isChangeOrientation = true
  })

  eventer('resize', function () {
    if (resizeTimer) {
      clearTimeout(resizeTimer)
      resizeTimer = false
    }

    resizeTimer = setTimeout(function () {
      visme_resp()
      resizeTimer = false
    }, 300)
  })

  // Listen to message from child window
  eventer(
    messageEvent,
    function (e) {
      if (e.origin.indexOf('visme') === -1) {
        return
      }
      var key = e.message ? 'message' : 'data'
      var data = e[key]
      if (data.event === 'title') {
        var x = document.getElementsByClassName('visme')
        var i
        for (i = 0; i < x.length; i++) {
          if (x[i].dataset.projectid == data.projectid || x[i].contentWindow == e.source) {
            x[i].title = data.title
          }
        }
      }
      if (data.event === 'hyperlink' && data.target === 'same_window') {
        window.location = data.args
      }
    },
    false
  )

  // to be able to call it from "outside"
  window.setup_visme = setup_visme
}
/* eslint-enable */
